import {
  CREATE_BATCH,
  CREATE_BATCH_SUCCESS,
  CREATE_BATCH_FAIL,
  CREATE_BATCH_RESET,
} from '../actions/createBatchAction';

const initialState = {
  apiState: '',
  message: '',
  data: null,
  error: '',
};

const createBatchReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_BATCH:
      return {
        ...state,
        apiState: 'loading',
      };
    case CREATE_BATCH_SUCCESS:
      return {
        ...state,
        apiState: 'success',
        data: action.response.data,
        message: action.response.message || 'success',
      };
    case CREATE_BATCH_FAIL:
      return {
        ...state,
        apiState: 'error',
        error: action.response.errors,
        message: action.response.message || 'error',
      };
    case CREATE_BATCH_RESET:
      return initialState;
    default:
      return state;
  }
};

export default createBatchReducer; 